import axios from 'axios'
import util from '../util'

export default class ProductService {
  static async searchProduct ( searchRequest, request ){
    const params = new URLSearchParams()
    if (util.isEan(searchRequest.searchText)) {
      params.append('id', searchRequest.searchText)
    } else {
      params.append('name', searchRequest.searchText)
    }
    if(searchRequest.active) {
      params.append('active', searchRequest.active)
    }

    if (request != null) {
      params.append('source', request.source)
    } else {
      params.append('source', process.env.VUE_APP_DEFAULT_PRODUCT_SOURCE)
      params.append('source', 'LOCAL')
    }
    params.append('noBundles', request == null ? false : request.noBundles)
    params.append('pageSize', process.env.VUE_APP_MAX_RESULT_PER_PAGE)

    return axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/product/' , {
        params: params
      })
      .then(response => response.data)
    }

    static async deleteLocalProduct (ean) {
      return axios
        .delete(process.env.VUE_APP_INTERNAL_API_BASEURL + '/product/' + 'LOCAL/' + 'EAN/' + ean)
    }
}
